/* ============
 * Actions for the account module
 * ============
 *
 * The actions that are available on the
 * account module.
 */

import * as types from './mutation-types'

import { agreePolicy } from '@/services/user/'

export const loadSaved = ({ commit }) => {
  const data = localStorage.getItem('accessToken')
  if (data) {
    commit(types.STORE, { email: data })
  }
}

export const store = ({ commit }, payload) => {
  commit(types.STORE, payload)
}

export const update = ({ commit }, payload) => {
  commit(types.UPDATE, payload)
}

export const check = ({ commit, state }) => {
  commit(types.CHECK)
}

export const load = ({ commit, state }) => {
  commit(types.STORE, state.accountLoaded)
  // commit(types.UNLOAD)
}

export const submitPolicyAgreement = async({ commit }) => {
  try {
    agreePolicy()
      .then(() => {
        commit(types.SET_AGREE_POLICY)
      })
  } catch (error) {
    console.log(error)
  }
}

export default {
  store,
  update,
  loadSaved,
  check,
  load,
  submitPolicyAgreement
}
